import { DEFAULT_THEME } from '@apps-common/config/theme'
import type { PortalThemeModel, ThemePayload } from '@apps-common/types/portal/theme'

export const hydrateTheme = (theme?: PortalThemeModel | null): PortalThemeModel => {
  if (!theme) return DEFAULT_THEME

  // Already hydrated
  if (theme.palettes) return theme

  // Missing JSON → fall back to default palettes
  if (!theme.palettesJson) {
    return {
      ...theme,
      palettes: DEFAULT_THEME.palettes
    }
  }

  try {
    const palettes = JSON.parse(theme.palettesJson) as ThemePayload

    return {
      ...theme,
      palettes
    }
  } catch {
    return {
      ...theme,
      palettes: DEFAULT_THEME.palettes
    }
  }
}
